import DOMPurify from 'dompurify';
import extractText from './extractText';

const seoScriptProps = (
  jsonLd: { raw: string },
  contentParser = (content: string) => content,
  structuredData?: string,
): Record<string, any> | null => {
  // This solution until we fully migrate the all ld+json data
  function sanitizeScriptElement(data: string | undefined) {
    if (data && DOMPurify.sanitize) {
      const sanitized = DOMPurify.sanitize(data, { ALLOWED_TAGS: ['script'], FORCE_BODY: true, RETURN_DOM: true });
      return sanitized.firstElementChild;
    }
    return null;
  }
  const newStructure =
    structuredData && `<script type='application/ld+json'>${JSON.stringify(structuredData)}</script>`;
  const scriptHTMLElement = sanitizeScriptElement(jsonLd?.raw) || sanitizeScriptElement(newStructure);
  // Temporary until fix image urls on WP
  const scriptHtmlContent = scriptHTMLElement?.firstChild
    ? extractText(contentParser(DOMPurify.sanitize(scriptHTMLElement.firstChild)).replaceAll('&amp;', '&'))
    : '';

  return (
    scriptHTMLElement && {
      ...Array.from({ length: scriptHTMLElement.attributes.length })
        // loop through script attributes to create a prop object like { class: "rank-math-schema", ...}
        // initial value is setting scriptHTMLElement (script child) to dangerouslySetInnerHTML
        .reduce(
          (acc: Record<string, any>, _curr, index) => {
            acc[scriptHTMLElement.attributes[index].nodeName] = scriptHTMLElement.attributes[index].nodeValue;
            return acc;
          },
          {
            ...(scriptHTMLElement.firstChild && { dangerouslySetInnerHTML: { __html: scriptHtmlContent } }),
          },
        ),
    }
  );
};

export default seoScriptProps;
